"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_FONT_LENGTH = exports.REFRESH_POSTS_LIST = void 0;
exports.REFRESH_POSTS_LIST = 'REFRESH_POSTS_LIST';
exports.MAX_FONT_LENGTH = 1000;
